export default function mapTag(tagName) {

    const allTags = gd.session.projects.allTags().models;

    const tag = _.find(allTags, curTag=>{
        return curTag.name.toLowerCase()===tagName.trim().toLowerCase();
    });

    if (tag) {
        return tag.id;
    }

    return null;


}
